import { useState } from 'react';

import { sortByIdOrder } from '@/pages/Customize/lib';

import { Slider } from '@/features/slider';

import { WidgetSchema } from '@/entities/widget';

import { useResponsive } from '@/shared/lib';

import { useCustomizationStore } from '../model/store';
import { ComingSoonWidget } from './ComingSoonWidget';
import { WIDGETS_MAP } from './Widgets';

interface WidgetsSliderProps {
  className?: string;
  pagination?: boolean;
  cursor?: boolean;
  contentClassName?: string;
  disableInteractions?: boolean;
}

export const generateWidgets = (widgets: WidgetSchema[]) => {
  return widgets
    .filter((widget) => widget.type !== 'exchange') // TODO: restore Exchange
    .map((widget) => {
      const Component = WIDGETS_MAP[widget.type];

      if (Component) {
        return {
          ...widget,
          content: <Component widget={widget} />,
        };
      }

      return { ...widget, content: <ComingSoonWidget widget={widget} /> };
    });
};

export const WidgetsSlider = ({
  className,
  pagination,
  cursor,
  contentClassName,
  disableInteractions = false,
}: WidgetsSliderProps) => {
  const widgets = useCustomizationStore((state) => state.widgets);
  const mobileOrder = useCustomizationStore((state) => state.mobileOrder);
  const { isMobile } = useResponsive();

  const displayWidgets = generateWidgets(widgets);
  const displayMobileWidgets = generateWidgets(
    sortByIdOrder(mobileOrder, widgets),
  );

  const [activeSlide, setActiveSlide] = useState(0);
  const [activeSlideMobile, setActiveSlideMobile] = useState(1);

  const mainIndex = displayMobileWidgets.findIndex(
    (item) => item.type === 'account-main',
  );

  return isMobile ? (
    <Slider
      className={className}
      slides={displayMobileWidgets}
      activeSlide={activeSlideMobile}
      setActiveSlide={setActiveSlideMobile}
      pagination={pagination}
      cursor={cursor}
      contentClassName={contentClassName}
      disableInteractions={disableInteractions}
      opts={{ startIndex: mainIndex }}
    />
  ) : (
    <Slider
      className={className}
      slides={displayWidgets}
      activeSlide={activeSlide}
      setActiveSlide={setActiveSlide}
      pagination={pagination}
      cursor={cursor}
      contentClassName={contentClassName}
      disableInteractions={disableInteractions}
    />
  );
};
